export default class SendDuplicataModel {
    public idDemandeDuplicata = 0
    public mail = ''
    public corps = ''
    public files = new Array<File>()
}
